import React, { useEffect, useState } from 'react';
import PrivateLayout from '../../../layouts/PrivateLayout/PrivateLayout';
import { FaArrowLeft, FaShare } from 'react-icons/fa';
import { Button } from 'flowbite-react';
import { Link, useNavigate } from 'react-router-dom';
import icon from '../../../assets/recovery-convert.png';
import client from '../../../api/client';
import showToast from '../../../components/CustomToast/toastHelper';
import moment, { Moment } from 'moment';
import StatusView from '../../../components/StatusView/StatusView';

interface PaymentSummaryModalProps{
    billPaymentId:number,
    onclose:()=>void
}
const PaymentSummaryModal = ({ billPaymentId, onclose }: PaymentSummaryModalProps) => {
    const [paymentDetails, setPaymentDetails] = useState<any>(null);
    const [transaction, setTransaction] = useState<any[]>([])
    const navigate = useNavigate()
    const fetchBillPaymentDetails = async () => {
        try {
            const apiUrl = `subsidiary/dashboard/bills-payment/single-details/${billPaymentId}`;
            const response = await client.get(`${apiUrl}`);
            setPaymentDetails(response.data.data);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, 'error');
            }
        }
    };

    const closeModal =()=>{
        navigate('/bills-payment/history')
        onclose()
    }

    useEffect(() => {
        fetchBillPaymentDetails();
    }, []);

    useEffect(() =>{
        if(paymentDetails){
            let currency = paymentDetails.currencyId = 1 ?"NGN" : ""
            let status = paymentDetails.statusId == 5 ?"Successful" : paymentDetails.statusId == 4 ?"Failed":paymentDetails.statusId == 2 ?"Pending":paymentDetails.statusId == 1 ?"Initiated":""
            const initialDetails = [
                {label: "Biller", value:paymentDetails.billerCode},
                {label: "Amount", value:`${currency} ${paymentDetails.amount}`},
                {label: "Fee", value:`${currency} ${paymentDetails.fee}`},
                {label: "CustomerId", value:paymentDetails.customerId},
                {label: "Product", value:paymentDetails.itemCode},
                {label: "Merchant Reference", value:paymentDetails.merchantReference},
                {label: "Transaction Reference", value:paymentDetails.transactionReference},
                {label: "Provider Reference", value:paymentDetails.providerReference},
                {label: "Response Message", value:paymentDetails.responseMessage},
                {label: "Token", value:paymentDetails?.token ?? "N/A"},
                {
                    label: 'Status',
                    value: <StatusView status={status} green="Successful" red="Failed" orange="Initiated" />,
                },
                {label: "Date Initiated", value:(moment.utc(paymentDetails?.dateCreated).local() as Moment).format('DD-MMM-YYYY hh:mm:ss a')},
            ]
            setTransaction(initialDetails)

        }

    }, [paymentDetails])

    return (
        <div className="flex justify-center">
            <div className="my-10 mx-6 w-full  lg:shadow lg:p-6">
                <div>
                    <img src={icon} className="my-3" alt="icon" />
                    <div className="my-3">
                        <p className="text-xl font-bold">Transaction Details</p>
                        <p className="text-sm">Kindly find your transaction details below</p>
                    </div>
                </div>
                <div>
                {transaction.map((detail: any, index: number) => (
                            <div key={index}>
                                <div className="flex my-4 items-center text-xs">
                                    <p>{detail.label}</p>
                                    <p className="font-semibold ml-auto text-right">{detail.value}</p>
                                </div>
                                <hr />
                            </div>
                        ))}
                </div>

                <div className="flex flex-col md:flex-row gap-3 justify-center my-4 print:!hidden">
                        <Button onClick={()=>closeModal()} className="rounded-full w-full bg-custom-button-green">
                            <div className="flex items-center gap-2">
                                <FaArrowLeft />
                                Back to bills
                            </div>
                        </Button>
                    {/* <Button className="rounded-full bg-custom-button-green">
                        <div className="flex items-center gap-2">
                            <FaShare />
                            <p>Download</p>
                        </div>
                    </Button> */}
                </div>
            </div>
        </div>
    );
};

export default PaymentSummaryModal;
